import { TemplateApiModel } from './template.model';

export type ArcgisCivil3dSettingConfigurationApiModel = {
  id: number;
  originalId?: number;
  name: string;
  template: { id: number };
};

export enum ArcgisCivil3dSettingConfigurationRelationship {
  TEMPLATE = 'TEMPLATE',
}

export type WithTemplate = ArcgisCivil3dSettingConfigurationApiModel & {
  template: TemplateApiModel;
};
